import InteractiveAnnotation from "./interactiveAnnotation";
import Ellipse from "./ellipse";
import { drawBoxes, measureText, setFontStyle } from "../canvasUtils";
import MeasurementText from "./measurementText";

export default class Area extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);

    this.ellipse = new Ellipse(position, options);
    this.measurementText = new MeasurementText();
    this.textActive = false;
  }

  get textPosition(){
    let x = this.ellipse.centerX + (this.ellipse.radiusX + 15) * Math.cos(Math.PI / 4);
    let y = this.ellipse.centerY + (this.ellipse.radiusY + 15) * Math.sin(Math.PI / 4);
    return {x, y};
  }

  get text(){
    let area = this.ellipse.area * this.scale * this.scale;
    return area.toFixed(2) + " mm²";
  }

  get textWidth(){
    return measureText(this.text, this.font);
  }

  draw(ctx) {
    this.ellipse.draw(ctx);
    this.drawText(ctx);
    if (this.ellipse.isActive) drawBoxes(ctx, this.ellipse.getInteractionPoints(), this.transform.zoom);
    if (this.textActive) this.measurementText.drawTextInteractionBoxe(ctx);
  }

  drawText(ctx){
    setFontStyle(ctx, this);
    this.measurementText.updateAndDraw(this.textWidth, this.textSize, ctx, this.text, this.textPosition.x, this.textPosition.y);
  }

  isInBounds(x, y) {
    return this.ellipse.isInBounds(x, y) || this.measurementText.isInBound(x, y);
  }

  getHoverClass(x, y){
    return this.ellipse.getHoverClass(x, y);
  }

  mousedown(x, y){
    if(this.measurementText.isInBound(x, y)) this.textActive = true;
    else this.ellipse.mousedown(x, y);
    this.signalReady();
  }

  mousemove(x, y){
    if(this.textActive) this.measurementText.updateLocation(x, y);
    else this.ellipse.mousemove(x, y);
    this.signalReady();
  }

  deactivate(){
    this.textActive = false;
    this.ellipse.deactivate();
    this.signalReady();
  }

  setLineWidth(width) {
    this.ellipse.setLineWidth(width);
    this.signalReady();
  }

  updateColor(color) 
  {
    this.ellipse.color = color;
    this.color = color;
  }
}